// import {
//   BrandPayload,
//   BrandSubmitForm,
//   Brands,
//   UpdateBrandStatus,
// } from "models/brand";
// import { BrandLocationPayload, BrandLocations, BrandList } from "models/brandLocation";
import { BrandList, StoreList } from "models/document";
import { PackageUpdateForm } from "models/package";
import axiosClient from "./axiosClient";
import { ApiResponse, RemovePayload, DocumentUrlData } from "models";
// import { ApiResponse, RemovePayload } from "models";

const packageApi = {
  getModuleList(): Promise<any> {
    const url = "/roleModuleManage/getAllModuleName";
    return axiosClient.get(url, {});
  },

  getPackageList(data: any): Promise<any> {
    const url = `/packageManage/getAllPackage?limit=${data.limit || ""}&page=${
      data.page || ""
    }&region=${data.region || ""}&search=${data.search || ""}&sortField=${
      data.sortName || ""
    }&sortType=${data.sortType || ""}`;
    return axiosClient.get(url);
  },

  addPackage(data: any): Promise<ApiResponse> {
    const url = `/packageManage/addPackage`;
    return axiosClient.post(url, data, {
      // headers: {
      //   "Content-Type": "multipart/form-data",
      // },
    });
  },

  updatePackage(data: PackageUpdateForm): Promise<ApiResponse> {
    const url = `/packageManage/updatedaPackage`;
    return axiosClient.put(url, data);
  },

  deletePackage(data: RemovePayload): Promise<ApiResponse> {
    const url = `/packageManage/removePackage?id=${data._id}`;
    return axiosClient.post(url);
  },

  // getImageUrl(data: ImageUrlData): Promise<ApiResponse> {
  //   const url = `/settings/uploadImage`;
  //   return axiosClient.post(url, data, {
  //     headers: {
  //       "Content-Type": "multipart/form-data",
  //     },
  //   });
  // },

  brandListApi(data: BrandList): Promise<ApiResponse> {
    const url = `/brand/getBrandByCustomerId?customerID=${data.customerId}`;
    return axiosClient.get(url, {});
  },

  storeListApi(data: StoreList): Promise<ApiResponse> {
    const url = `/store/getStoreByBrandId?brandId=${data.brandId}`;
    return axiosClient.get(url, {});
  },

  getDocumentUrl(data: DocumentUrlData): Promise<ApiResponse> {
    const url = `/settings/uploadImage`;
    return axiosClient.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export default packageApi;
